import { Injectable, signal } from '@angular/core';
import { ToastComponent } from '../../shared/components/toast/toast.component';

export interface ToastMessage {
  id: number;
  titleMsg: string;
  message: string;
  type: ToastMsgTypes['types'];
}

export interface ToastMsgTypes {
  types: 'success' | 'error' | 'warning';
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private counter = 0;
  toasts = signal<ToastMessage[]>([]);
  private toastRef!: ToastComponent;

  register(component: ToastComponent) {
    this.toastRef = component;
  }

  show(titleMsg: string, message: string = '', type: 'success' | 'error' | 'warning') {
    const id = ++this.counter;
    const newToast: ToastMessage = {id, titleMsg, message, type};
    this.toasts.update((list) => [...list, newToast]);
    setTimeout(() => this.dismiss(id), 3000);
  }

  dismiss(id: number) {
    this.toasts.update((list => list.filter(t => (t.id !== id))));
  }

}
